import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Pagination, Dropdown } from "semantic-ui-react";

const options = [
  { key: 10, text: "10 per page", value: 10 },
  { key: 50, text: "50 per page", value: 50 },
  { key: 100, text: "100 per page", value: 100 },
];

const Paginator = ({ total, pageBy, setPageBy, page, path }) => {
  const navigate = useNavigate();

  const pages = Math.ceil(total / pageBy);
  const [activePage, setActivePage] = useState(parseInt(page));

  const handleClick = (event, data) => {
    navigate(`${path}${data.activePage}`);
  };

  useEffect(() => {
    setActivePage(parseInt(page));
  }, [page]);

  return (
    <>
      <div className="paginator" style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "center" }}>
        {pages > 1 && (
          <Pagination
            boundaryRange={0}
            totalPages={pages}
            onPageChange={handleClick}
            activePage={activePage}
            size="mini"
          />
        )}
        {setPageBy && (total > 10 || pageBy > 10) && (
          <Dropdown
            compact
            selection
            options={options}
            value={pageBy}
            onChange={(e, { value }) => {
              setPageBy(value);
              // reset to page 1 if changing pageBy could go out of bounds
              if (path) {
                navigate(`${path}1`);
              }
            }}
          />
        )}
      </div>
    </>
  );
};

export default Paginator;
